module.exports = __webpack_public_path__ + "static/media/HM.d6c959c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/countryFlags/HM.svg
// module id = 1958
// module chunks = 0